// ----------------------------------------------------------------------
// <copyright file='Izenda.SaveReportButton.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var Button = require('share/components/controls/Izenda.Button');
  var SavePopup = require('modules/ReportDesigner/SavePopup/Izenda.SavePopup');
  var ACCESS_RIGHT = require('logic/data/Izenda.AuthorizationConstants').ACCESS_RIGHT;

  var connect = require('share/enhancers/Izenda.Connect');
  var routeUtils = require('share/utils/Izenda.RouteUtils');
  var uiState = require('logic/Izenda.UiState');
  const { isNil } = require('lodash/fp');

  var SaveReportButton = React.createClass({
    propTypes: {
      fieldStore: React.PropTypes.object.isRequired,
      subscribedInstancesStore: React.PropTypes.object.isRequired,
      viewMode: React.PropTypes.bool.isRequired,
      confirmFn: React.PropTypes.func.isRequired
    },
    render: function() {
      var props = this.props;
      var accessPriority = props.accessPriority;
      var localization = this.props.localization;
      var saveAsPermission =
        props.authorization.checkPrivileges([
          props.authorizationConstants.PERMISSION_KEY.ReportsCanCreateNewReportValue
        ]) &&
        (accessPriority === ACCESS_RIGHT.FullAccess ||
          accessPriority === ACCESS_RIGHT.QuickEdit ||
          accessPriority === ACCESS_RIGHT.SaveAs);

      var savePermission =
        (props.authorization.checkPrivileges([
          props.authorizationConstants.PERMISSION_KEY.ReportsActionsOverwriteExistingReport
        ]) &&
          accessPriority === ACCESS_RIGHT.FullAccess &&
          !props.boardDetail.isGlobal) ||
        (props.boardDetail.isGlobal && uiState.currentUser.systemAdmin && !uiState.tenantId);

      if (saveAsPermission && savePermission && props.active) {
        return (
          <div className='btn-group'>
            <Button
              className='dropdown-toggle'
              data-toggle='dropdown'
              label={localization.getText('COMMON_LABEL_SAVE')}
            >
              <span className='caret' />
            </Button>
            <ul className='dropdown-menu'>
              <li>
                <a onClick={this.props.onSave}>{localization.getText('COMMON_LABEL_SAVE')}</a>
              </li>
              <li>
                <a onClick={this.onSaveAs}>{localization.getText('COMMON_LABEL_SAVE_AS')}</a>
              </li>
            </ul>
          </div>
        );
      }

      if (savePermission && props.active) {
        return <Button onClick={props.onSave} label={localization.getText('COMMON_LABEL_SAVE')} />;
      }

      if (saveAsPermission) {
        return <Button onClick={this.onSaveAs} label={localization.getText('COMMON_LABEL_SAVE_AS')} />;
      }

      return null;
    },
    /**
     * Save As Report Designer:
     *  - Validate data > if data valid > open SaveAs Popup for new Report
     */
    onSaveAs: function() {
      var props = this.props;
      var fieldStore = props.fieldStore;
      var reportDesignerStore = fieldStore.reportStore;
      reportDesignerStore.canSaveAs = true;

      // TODO : Validate Filter here

      return this.openPopup(true);
    },

    openPopup: function(saveAs) {
      var props = this.props;
      var fieldStore = props.fieldStore;
      var reportDesignerStore = fieldStore.reportStore;

      function showSavePopup() {
        return props.openPopup(SavePopup, {
          store: reportDesignerStore,
          onSaved: this.onCloseSavePopup,
          saveAsMode: saveAs,
          fieldStore: fieldStore
        });
      }

      return isNil(reportDesignerStore.model.categoryId) ||
        (reportDesignerStore.model.isGlobal && !isNil(reportDesignerStore.fieldsStore.tenantId) && saveAs)
        ? reportDesignerStore.loadCategories().then(showSavePopup.bind(this))
        : Promise.join(
            reportDesignerStore.loadCategories(),
            reportDesignerStore.loadSubCategories(reportDesignerStore.model.categoryId)
          ).then(showSavePopup.bind(this));
    },

    onCloseSavePopup: function(newReportId) {
      var router = this.props.router;

      if (newReportId) {
        this.props.reportStore && this.props.reportStore.resetReportData();
        router.push(this.buildViewerLink(newReportId));
      }
    },
    buildViewerLink: function(newReportId) {
      var mode = this.props.viewMode ? 'View' : 'Edit';

      return routeUtils.getReportUrl(mode, { id: newReportId });
    }
  });

  module.exports = connect()(SaveReportButton);
})();



// WEBPACK FOOTER //
// ./ui/modules/Reports/Buttons/Izenda.SaveReportButton.jsx